import { currentDevice } from '../../core/utils/currentDevice'
import Modal from '../../shared/modal/modal'
import on from '../../utils/events_delegation'
import BottomSheet from '../bottom_sheet/bottom_sheet'
;

(function () {
  const $block = document.querySelectorAll('.booking-modal')
  const ONLINE_BOOKINGS_DISABLED = document
    .getElementsByTagName('body')[0]
    .classList.contains('js-force-callcenter-lightbox')

  // PY04777-786 - 762762 - Boton cancelar en mis reservas
  // Fix modal lock when opening a second modal
  let dataCancelModal = {}

  if (!$block.length) {
    return
  }

  const BOOKING_MODAL_CANCEL_SELECTOR = 'booking-modal-cancel'
  const BOOKING_MODAL_CONDITIONS_SELECTOR = 'booking-modal-conditions'
  const BOOKING_MODAL_MODIFY_SELECTOR = 'booking-modal-modify'
  const BOOKING_MODAL_POINTS_SELECTOR = 'booking-modal-points'
  const BOOKING_MODAL_CHECK_IN_SELECTOR = 'booking-modal-check-in'
  const POINTERS_STAR_AGENTS_SELECTOR = 'pointers-star-agents'
  const BOOKING_MODAL_PAY_STATE_SELECTOR = 'pay-state'

  if (!ONLINE_BOOKINGS_DISABLED) {
    if (currentDevice.isMobile) {
      // --------------------------------------------------
      // CANCEL BOOKING BOTTOM SHEET
      // --------------------------------------------------
      const cancelBottomSheet = new BottomSheet({ sheetId: BOOKING_MODAL_CANCEL_SELECTOR })
      const cancelBottomSheetElem = cancelBottomSheet.getBottomSheetElem()
      const closeCta = cancelBottomSheetElem.querySelector('.js-booking-modal-close')

      closeCta?.addEventListener('click', e => {
        e.preventDefault()
        cancelBottomSheet.close()
      })

      on({
        eventName: 'click',
        selector: `.js-booking-cancel-link`,
        handler: e => {
          e.preventDefault()
          const element = e.target

          cancelBottomSheet.show(bottomSheet => {
            const link = element.dataset.link
            const conditions = element.dataset.conditions
            bottomSheet.querySelector('.js-link-conditions').dataset.conditions = conditions
            bottomSheet.querySelector(`.${BOOKING_MODAL_CANCEL_SELECTOR}-link`).href = link
          })
        },
      })

      // --------------------------------------------------
      // MODIFY BOOKING BOTTOM SHEET
      // --------------------------------------------------
      const modifyBottomSheet = new BottomSheet({ sheetId: BOOKING_MODAL_MODIFY_SELECTOR })

      on({
        eventName: 'click',
        selector: `.js-link-modify`,
        handler: e => {
          e.preventDefault()
          const element = e.target

          modifyBottomSheet.show(bottomSheet => {
            const link = element.dataset.link
            bottomSheet.querySelector(`.${BOOKING_MODAL_MODIFY_SELECTOR}-link`).href = link
          })
        },
      })

      // --------------------------------------------------
      // POINTS STAR AGENTS BOTTOM SHEET
      // --------------------------------------------------
      const pointsStarAgentsBottomSheet = new BottomSheet({ sheetId: POINTERS_STAR_AGENTS_SELECTOR })

      on({
        eventName: 'click',
        selector: `.js-link-pointers-star-agents`,
        handler: e => {
          e.preventDefault()

          pointsStarAgentsBottomSheet.show()
        },
      })
    } else {
      // --------------------------------------------------
      // BOOKING CANCEL MODAL
      // --------------------------------------------------
      on({
        eventName: 'click',
        selector: `.js-booking-cancel-link`,
        handler: event => {
          event.preventDefault()
          const el = event.target
          const dataLink = el.dataset.link
          const dataConditions = el.dataset.conditions
          openBookingModal(BOOKING_MODAL_CANCEL_SELECTOR, dataLink, dataConditions)
        },
      })

      // --------------------------------------------------
      // BOOKING MODIFY MODAL
      // --------------------------------------------------
      on({
        eventName: 'click',
        selector: `.js-link-modify`,
        handler: event => {
          event.preventDefault()
          const el = event.target
          const dataLink = el.dataset.link
          openBookingModal(BOOKING_MODAL_MODIFY_SELECTOR, dataLink)
        },
      })

      // --------------------------------------------------
      // STAR AGENTS POINTS MODAL
      // --------------------------------------------------
      on({
        eventName: 'click',
        selector: `.js-link-pointers-star-agents`,
        handler: event => {
          event.preventDefault()
          const el = event.target
          const dataLink = el.dataset.link
          openBookingModal(POINTERS_STAR_AGENTS_SELECTOR, dataLink)
        },
      })
    }
  }

  // --------------------------------------------------
  // BOOKING CONDITIONS
  // --------------------------------------------------
  let conditionsBottomSheet

  if (currentDevice.isMobile) {
    conditionsBottomSheet = new BottomSheet({ sheetId: BOOKING_MODAL_CONDITIONS_SELECTOR })
  }

  on({
    eventName: 'click',
    selector: `.js-link-conditions`,
    handler: e => {
      e.preventDefault()
      const element = e.target
      const conditionsContent = element.dataset.conditions
      if (currentDevice.isMobile) {
        if (!conditionsBottomSheet) return

        conditionsBottomSheet.show(bottomSheet => {
          bottomSheet.querySelector(`.${BOOKING_MODAL_CONDITIONS_SELECTOR}-description p`).innerHTML = conditionsContent

          // content has changed, so height needs to be recalculated
          conditionsBottomSheet.calcInitialSheetHeight()
        })
      } else {
        openConditionsModal(BOOKING_MODAL_CONDITIONS_SELECTOR, conditionsContent)
      }
    },
  })

  // --------------------------------------------------
  // SELECT GIFT
  // --------------------------------------------------
  on({
    eventName: 'click',
    selector: `.js-link-select-gift`,
    handler: event => {
      event.preventDefault()
      const el = event.target
      const dataLink = el.dataset.link
      openBookingModal(BOOKING_MODAL_POINTS_SELECTOR, dataLink)
    },
  })

  $(document).on('click', '.link-payment-method', function (event) {
    event.preventDefault()
    Modal.close()
    const $el = $(this)
    openPaymentMethodModal('booking-modal-payment-method', $el.attr('data-payment-method'))
  })

  // --------------------------------------------------
  // CHECK IN
  // --------------------------------------------------
  let checkInBottomSheet

  if (currentDevice.isMobile) {
    // Create bottom sheet
    checkInBottomSheet = new BottomSheet({ sheetId: BOOKING_MODAL_CHECK_IN_SELECTOR })
    const checkInBottomSheetElem = checkInBottomSheet.getBottomSheetElem()
    const closeCta = checkInBottomSheetElem.querySelector('.js-booking-modal-close')

    closeCta?.addEventListener('click', e => {
      e.preventDefault()
      checkInBottomSheet.close()
    })
  }

  on({
    eventName: 'click',
    selector: `.js-link-check-in`,
    handler: event => {
      event.preventDefault()
      const el = event.target

      if (currentDevice.isMobile) {
        // BOTTOM SHEET
        checkInBottomSheet.show(bottomSheet => {
          const link = el.dataset.link
          bottomSheet.querySelector(`.${BOOKING_MODAL_CHECK_IN_SELECTOR}-link`).href = link
        })
      } else {
        // MODAL
        const dataLink = el.dataset.link
        openBookingModal(BOOKING_MODAL_CHECK_IN_SELECTOR, dataLink)
      }
    },
  })

  // --------------------------------------------------
  // PAY STATE
  // --------------------------------------------------
  let payStateBottomSheet

  if (currentDevice.isMobile) {
    // Create bottom sheet
    payStateBottomSheet = new BottomSheet({ sheetId: BOOKING_MODAL_PAY_STATE_SELECTOR })
  }

  on({
    eventName: 'click',
    selector: `.js-pay-state`,
    handler: event => {
      event.preventDefault()
      const el = event.target
      const payState = el.dataset.payState
      const stateClass = payState === 'true' ? 'pay' : 'no-pay'

      if (currentDevice.isMobile) {
        // BOTTOM SHEET
        payStateBottomSheet.show(bottomSheet => {
          bottomSheet.classList.add(stateClass)

          // content has changed, so height needs to be recalculated
          payStateBottomSheet.calcInitialSheetHeight()
        })

        payStateBottomSheet.addEventListener('close', bottomSheet => {
          bottomSheet.classList.remove(stateClass)
        })
      } else {
        // MODAL
        openPayStatusModal(BOOKING_MODAL_PAY_STATE_SELECTOR, payState)
      }
    },
  })

  function openPayStatusModal(selector, state) {
    const pay_state = state === 'true' ? 'pay' : 'no-pay'
    Modal.show(selector, {
      onShow: () => {
        ScrollLock.on()
        $('.pay-state-modal').addClass(pay_state)
      },
      onClose: () => {
        ScrollLock.off()
        $('.pay-state-modal').removeClass(pay_state)
      },
      awaitCloseAnimation: true,
    })
  }

  // --------------------------------------------------
  // OPEN MODAL MANAGERS
  // --------------------------------------------------
  function openBookingModal(selector, link) {
    Modal.show(selector, {
      onShow: () => {
        ScrollLock.on()
        $(`.${selector}-link`).attr('href', link)
      },
      onClose: () => {
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
    })
  }

  function openPayStatusModal(selector, state) {
    const pay_state = state === 'true' ? 'pay' : 'no-pay'
    Modal.show(selector, {
      onShow: () => {
        ScrollLock.on()
        $('.pay-state-modal').addClass(pay_state)
      },
      onClose: () => {
        ScrollLock.off()
        $('.pay-state-modal').removeClass(pay_state)
      },
      awaitCloseAnimation: true,
    })
  }

  function openCancelModal(selector, link, conditions) {
    // PY04777-786 - 762762 - Boton cancelar en mis reservas
    // Store information on who is launching the event
    dataCancelModal = { selector, link, conditions }

    Modal.show(selector, {
      onShow: () => {
        ScrollLock.on()
        $(`#${selector}`).find('.link-conditions').attr('data-conditions', conditions)
        $(`.${selector}-link`).attr('href', link)
      },
      onClose: () => {
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
    })

    return dataCancelModal
  }

  function openConditionsModal(selector, text) {
    // PY04777-786 - 762762 - Boton cancelar en mis reservas
    // Check if another modal is open before launching this one.
    const modalOpen = Array.from(document.querySelectorAll('.micromodal-slide.is-open'))

    // Close previous modal if exists
    modalOpen.length && Modal.close()

    Modal.show(selector, {
      onShow: () => {
        ScrollLock.on()
        $(`.${selector}-description p`).html(text)
      },
      onClose: () => {
        ScrollLock.off()

        // When closing the modal, open the one that triggered the condition modal.
        if (modalOpen.length) {
          openCancelModal(dataCancelModal.selector, dataCancelModal.link, dataCancelModal.conditions)
        }
      },
      awaitCloseAnimation: true,
    })
  }

  function openPaymentMethodModal(selector, text) {
    Modal.show(selector, {
      onShow: () => {
        ScrollLock.on()
        $(`.${selector}-description p`).html(text)
      },
      onClose: () => {
        ScrollLock.off()
      },
      awaitCloseAnimation: true,
    })
  }

  $(document).on('click', '.booking-modal-link', function () {
    Modal.close()
  })

  if (!currentDevice.isMobile) {
    $(document).on('click', '.js-booking-modal-close', function (event) {
      event.preventDefault()
      Modal.close()
    })
  }

  // --------------------------------------------------
  // INVOICE
  // --------------------------------------------------
  const invoicesBottomSheets = {}

  on({
    eventName: 'click',
    selector: `.js-invoice-info`,
    handler: e => {
      e.preventDefault()
      const element = e.target
      const contentId = element.dataset.modalFacturaInvoice

      if (currentDevice.isMobile) {
        if (!invoicesBottomSheets[contentId]) {
          invoicesBottomSheets[contentId] = new BottomSheet({ sheetId: contentId })
        }

        invoicesBottomSheets[contentId].show()
      } else {
        Modal.show(contentId, {
          onShow: () => {
            ScrollLock.on()
          },
          onClose: () => {
            ScrollLock.off()
          },
          awaitCloseAnimation: true,
        })
      }
    },
  })
})()
